import { useEffect, useState } from 'react';
import { Card, Col, CardBody, CardFooter, Table } from 'reactstrap';
import { H4, H6, Btn, Spinner } from 'AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters } from 'Features/Learning/PopupNotification/popupNotificationSlice';
import { setField } from 'Features/Learning/PopupNotification/addPopupNotificationSlice';
import {
  fetchPopupNotifications,
  handleDeletePopupNotification,
  handleEditPopupNotification,
  handleBackPagination,
  handleNextPagination,
  handleClickPagination
} from './PopupNotificationUtils';
import PaginationComponent from '../Common/Pagination';
import PopupNotificationPost from './PopupNotificationPost';

const PopupNotificationBox = ({ modal, toggle }) => {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.PopupNotification.filters)
  const cards = useSelector(state => state.PopupNotification.data.data)
  const pagination = useSelector(state => state.PopupNotification.data.pagination)
  const isLoading = useSelector(state => state.PopupNotification.isLoading)
  const [refatch, setRefatch] = useState(false)

  useEffect(() => {
    fetchPopupNotifications(dispatch, filters, setRefatch)
    window.scrollTo(0, 0);
  }, [dispatch, filters, refatch])

  return (
    <>
      {isLoading ? (
        <Col lg="12">
          <div className="loader-box">
            <Spinner attrSpinner={{ className: 'loader-30' }} />
          </div>
          <H6 attrH6={{ className: 'sub-title mb-0 text-center' }}>{'Data Loading...'}</H6>
        </Col>
      ) : (
        cards && cards.length > 0 && (
          <Col sm="12 order-2">
            <Card>
              <CardBody>
                <Table className="table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col" className="bg-primary text-light" style={{ width: '50px' }}>{'#'}</th>
                      <th scope="col" className="bg-primary text-light">{'Gambar'}</th>
                      <th scope="col" className="bg-primary text-light">{'URL'}</th>
                      <th scope="col" className="bg-primary text-light">{'Terlihat'}</th>
                      <th scope="col" className="bg-primary text-light">{'Ditampilkan di'}</th>
                      <th scope="col" className="bg-primary text-light text-center" width="100px">{'Aksi'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      cards && cards.map((item, index) =>
                        <tr key={`course-${index}`} className="table-light">
                          <th>{pagination?.from + index}</th>
                          <td>
                            {item?.image ? (
                              <img
                                src={item.image}
                                alt={`popup-${item?.id || index}`}
                                style={{ width: '120px', height: 'auto', objectFit: 'cover', borderRadius: '6px' }}
                              />
                            ) : (
                              '-'
                            )}
                          </td>
                          <td>
                            {/* URL dibuat clickable supaya mudah dicek oleh admin */}
                            {item?.url ? (
                              <a href={item.url} target="_blank" rel="noreferrer" style={{ wordBreak: 'break-all' }}>{item.url}</a>
                            ) : (
                              '-'
                            )}
                          </td>
                          <td>{item?.is_show ? 'Ya' : 'Tidak'}</td>
                          <td>{item?.target_page === 'home' ? 'Home' : item?.target_page === 'overview' ? 'Overview' : item?.target_page === 'both' ? 'Keduanya (Home + Overview)' : 'Tidak Ada Kunci'}</td>
                          <td className='text-center'>
                            <div>
                              <Btn
                                attrBtn={{
                                  color: 'link',
                                  outline: true,
                                  className: 'p-1',
                                  onClick: () => handleEditPopupNotification(dispatch, item, setField, toggle)
                                }}
                              >
                                <i className="fa fa-edit mx-auto text-secondary fa-lg"></i>
                              </Btn>
                              <Btn
                                attrBtn={{
                                  color: 'link',
                                  outline: true,
                                  className: 'p-1',
                                  onClick: () => handleDeletePopupNotification(dispatch, item?.id, setRefatch)
                                }}
                              >
                                <i className="fa fa-trash-o mx-auto text-danger fa-lg"></i>
                              </Btn>
                            </div>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                {pagination && (
                  <PaginationComponent
                    pagination={pagination}
                    handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefatch)}
                    handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefatch)}
                    handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefatch)}
                  />
                )}
              </CardFooter>
            </Card>
          </Col>
        )
      )}

      {(!cards || cards.length === 0) && (
        <Col lg="12">
          <H4 attrH4={{ className: 'sub-title mb-5 text-center' }}>{!cards ? 'Sumber Data Tidak Tersedia' : 'Data Tidak Ditemukan'}</H4>
        </Col>
      )}

      <PopupNotificationPost modal={modal} toggle={toggle} onSuccess={() => setRefatch(prev => !prev)} />

    </>
  );
};

export default PopupNotificationBox;